import "../styles/app.scss"
import "./shortcodes/briefcase/briefcaseApp.scss";
import "./shortcodes/catalog-page/CatalogPageApp.scss";
import './_images';

import BriefCaseItemsNumber from "./shortcodes/briefcase-items-number/BriefCaseItemsNumber";

document.addEventListener("DOMContentLoaded", () => {
    new BriefCaseItemsNumber();
}, false)